//VALIDAR INPUT Y RFC VALIDO SON FUNCIONES CREADAS POR
//https://es.stackoverflow.com/users/127/mariano
//https://es.stackoverflow.com/a/31714

//const clabe = require('./clabe.js');

exports.Methods = {
  methods: {
    rfcValido: function (rfc) {
      const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
      var validado = rfc.match(re);
      var aceptarGenerico = true;

      if (!validado)
          return false;

      //Separar el dígito verificador del resto del RFC
      const digitoVerificador = validado.pop(),
        rfcSinDigito = validado.slice(1).join(''),
        len = rfcSinDigito.length,
        diccionario = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
        indice = len + 1;
      var suma, digitoEsperado;

      if (len == 12) suma = 0
      else suma = 481; //Ajuste para persona moral

      for(var i = 0; i < len; i++)
          suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
      digitoEsperado = 11 - suma % 11;
      if (digitoEsperado == 11) digitoEsperado = 0;
      else if (digitoEsperado == 10) digitoEsperado = "A";

      //El dígito verificador coincide con el esperado?
      // o es un RFC Genérico (ventas a público general)?
      if ((digitoVerificador != digitoEsperado)
       && (!aceptarGenerico || rfcSinDigito + digitoVerificador != "XAXX010101000"))
          return false;
      else if (!aceptarGenerico && rfcSinDigito + digitoVerificador == "XEXX010101000")
          return false;
      return rfcSinDigito + digitoVerificador;
    },
    zipValid: function (code) {
      if(typeof(code) != 'string') code = code.toString();
      const re = /^[0-9]{5}\b/;
      let valid = code.match(re);
      return valid != null;
    },
    moneyValid: function (amount) {
      if(typeof(amount) != 'string') amount = amount.toString();
      const re = /^\$*\d{1,3}(,*\d{3})*(\.\d\d*)?$/;
      let valid = amount.match(re);
      return valid != null;
    },
    phoneValid: function (phone, type) {
      if(typeof(phone) != 'string') phone = phone.toString();
      let re;
      if(type)
        re = /^([0-9]{10})$/;
      else
        re = /^((01800[0-9]{7})|([0-9]{8,10}))$/;
      let valid = phone.match(re);
      return valid != null;
    },
    numberValid: function (num) {
      return !isNaN(num);
    },
    priceFormat: function (number) {
      return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    emailValid: function (email) {
      let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      let valid = email.match(re);
      return valid != null;
    },
    passValid: function (pass) {
      if(typeof(pass) != 'string') pass = pass.toString();
      let re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
      let valid = pass.match(re);
      return valid != null
    },
    clabeValid: function (num) {
      
    }
  }
}
